module.exports = __webpack_public_path__ + "img/arrow-up.1afd4a36.svg";